var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useFeatureFlagsContext } from '#context';
import { areExperimentalFeaturesEnabled, isEnabledFromFeatureFlag, } from '#services';
export const FeatureFlagGuard = ({ children, flagKey, flagName, flagValue, }) => {
    _react_refresh_temp_2();
    const { isError: isAmplitudeError, isPending, variants, } = useFeatureFlagsContext();
    const location = useLocation();
    if (isPending) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking permissions'), "data-testid": "checking-feature-flag", isFullHeight: true }) }));
    }
    if (isAmplitudeError) {
        /**
         * Fallback to experimental feature flag
         * to enable local development where
         * there is no Amplitude engaged:
         */
        return areExperimentalFeaturesEnabled() ? (children) : (_jsx(Navigate, { state: location.state, to: '/workspaces' }));
    }
    if (isEnabledFromFeatureFlag({
        flagKey,
        flagName,
        flagValue,
        variants,
    })) {
        return children;
    }
    return _jsx(Navigate, { state: location.state, to: '/workspaces' });
};
_react_refresh_temp_1 = FeatureFlagGuard;
$RefreshReg$(_react_refresh_temp_1, "FeatureFlagGuard");
_react_refresh_temp_2(FeatureFlagGuard, "QkbPZSXOiKMJ8VBp16LHY88p0W4=", false, () => [useFeatureFlagsContext, useLocation]);
